export default __webpack_public_path__ + "859efa28936a730d6a1b34f42ea72efa.svg";